import React from 'react';
import classNames from 'classnames';
import { types as sdkTypes } from '../../../util/sdkLoader';
import { formatMoney } from '../../../util/currency';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './CollectionAndShipping.module.css';

const { Money } = sdkTypes;

const CollectionAndShipping = ({ formApi, values = {}, listing, intl }) => {
  const {
    shipping,
    collection,
    chargeAmount,
  } = listing.attributes?.publicData ?? {};

  const collectionAndShippingOptions = [
    ...(collection ? [{
      label: <FormattedMessage id="BookingDatesForm.collection" />,
      value: <FormattedMessage id="BookingDatesForm.free" />,
      id: "collection",
    }] : []),
    ...(shipping ? [{
      label: <FormattedMessage id="BookingDatesForm.shipping" />,
      value: chargeAmount
        ? formatMoney(intl, new Money(chargeAmount.amount, chargeAmount.currency))
        : <FormattedMessage id="BookingDatesForm.free" />,
      id: "shipping",
    }] : []),
  ]


  const handleSelectOption = (id) => {
    const value = values.collectionOrShipping === id ? undefined : id;
    formApi.change("collectionOrShipping", value);
  }

  return (
    <div className={css.root}>
      <h2 className={css.title}>
        <FormattedMessage id="BookingDatesForm.collectionAndShippingHeadline" />
      </h2>

      <div>
        {collectionAndShippingOptions.map(({label, value, id}, index) => {
          const clsSelected = classNames(css.transportationOption, {
            [css.selected]: id === values.collectionOrShipping,
          })

          return (
            <div key={index} className={clsSelected} onClick={() => handleSelectOption(id)}>
              <div className={css.circle} />
              <div>
                <span className={css.transportationLabel}>{label}</span>
                <span className={css.transportationValue}>{value}</span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CollectionAndShipping;
